import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { AlertRuleCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { InputBoolean } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AlertRuleCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  alertTypeSelectedValue?: { displayId: string; id: string } | null;
  onAlertTypeChange?: (value: string) => void;
  alertType: string;
  alertTypeError?: string;
  enabledSelectedValue?: { displayId: string; id: string } | null;
  onEnabledChange?: (value: boolean) => void;
  enabled: boolean;
  enabledError?: string;
  paramsSelectedValue?: { displayId: string; id: string } | null;
  onParamsChange?: (value: string) => void;
  params: string;
  paramsError?: string;
  alertRuleCreateStore: AlertRuleCreateStore;
};

export const AlertRuleCreateForm: React.FC<AlertRuleCreateFormProps> = observer(
  ({
    onSave = () => {},
    onCancel = () => {},
    saving = false,
    showToolbox = true,
    showSaveFooter,
    alertType = "",
    alertTypeError,
    onAlertTypeChange = () => {},
    enabled = false,
    enabledError,
    onEnabledChange = () => {},
    params = "{}",
    paramsError,
    onParamsChange = () => {},
    alertRuleCreateStore,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            saveAndCloseLabel={langStore.saveEntity}
            closeLabel={langStore.cancelNewEntity}
            saveForm={() => onSave()}
            saveDisabled={saving}
            closeForm={() => onCancel()}
          />
        )}
        <Box>
          <FormExtras
            entity="AlertRule"
            mode="create"
            values={{}}
            options={{}}
            onPatch={(campo: string, valor: any) => {
              switch (campo) {
                case "alertType":
                  onAlertTypeChange?.(valor);
                  break;
                case "enabled":
                  onEnabledChange?.(valor);
                  break;
                case "params":
                  onParamsChange?.(valor);
                  break;
              }
            }}
          />
          <GroupContainer
            id="null"
            errorText={alertRuleCreateStore.getCardErrors("null")}
            title={langStore.groupAlertRuleLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <InputString
                autoFocus
                value={alertType}
                error={Boolean(alertTypeError)}
                warning={
                  !alertTypeError &&
                  Boolean(alertRuleCreateStore.warnings["alertType"])
                }
                helperText={
                  alertTypeError ||
                  alertRuleCreateStore.warnings["alertType"]?.message
                }
                label={langStore.AlertRuleAlertTypeLabel}
                onChange={(value: string) => onAlertTypeChange(value)}
                description={langStore.AlertRuleAlertTypeDescription}
              />
              <InputBoolean
                value={enabled}
                error={Boolean(enabledError)}
                helperText={
                  enabledError ||
                  alertRuleCreateStore.warnings["enabled"]?.message
                }
                label={langStore.AlertRuleEnabledLabel}
                onChange={(value: boolean) => onEnabledChange(value)}
              />

              <InputCodeEditor
                value={params}
                error={Boolean(paramsError)}
                helperText={
                  paramsError ||
                  alertRuleCreateStore.warnings["params"]?.message
                }
                label={langStore.AlertRuleParamsLabel}
                onChange={(value: string) => onParamsChange(value)}
                language="json"
                description={langStore.AlertRuleParamsDescription}
              />
            </FormControl>
          </GroupContainer>
        </Box>
        {(showSaveFooter ?? !showToolbox) && (
          <FormSaveFooter
            onSave={() => onSave()}
            label={langStore.saveEntity}
            disabled={saving}
          />
        )}
      </Grid>
    );
  }
);
